export const ORDER_FEED_CONNECT = 'ORDER_FEED_CONNECT' as const;

export const ORDER_FEED_DISCONNECT = 'ORDER_FEED_DISCONNECT' as const;

export const ORDER_FEED_MESSAGE = 'ORDER_FEED_MESSAGE' as const;

export const ORDER_FEED_ERROR = 'ORDER_FEED_ERROR' as const;

export const ORDER_FEED_CLOSE = 'ORDER_FEED_CLOSE' as const;

export const ORDER_FEED_OPEN = 'ORDER_FEED_OPEN' as const;

export const ORDER_FEED_CONNECTING = 'ORDER_FEED_CONNECTING' as const;
